/** When your routing table is too long, you can split it into small modules**/
import Layout from '@/layout';

const purchaseRoutes = {
  path: '/purchase',
  component: Layout,
  redirect: '/purchase',
  name: 'Purchase',
  alwaysShow: true,
  meta: {
    title: 'purchase',
    icon: 'ShoppingCart',
  },
  children: [

    // Purchase routes
    {
      path: 'purchases/list',
      component: () => import('../views/purchase/List'),
      name: 'purchaseList',
      meta: { title: 'purchaseList', icon: 'Memo', permissions: ['purchase view'] },
    },

    {
      path: 'purchases/create',
      component: () => import('../views/purchase/Create'),
      name: 'createPurchase',
      meta: { title: 'createPurchase', icon: 'edit', noCache: true, permissions: ['purchase create'] },
      hidden: true,
    },
    {
      path: 'purchases/view/:id',
      component: () => import('../views/purchase/View'),
      name: 'viewPurchase',
      meta: { title: 'viewPurchase', icon: 'edit', noCache: true, permissions: ['purchase view'] },
      hidden: true,
    },
    {
      path: 'purchases/edit/:id',
      component: () => import('../views/purchase/Edit'),
      name: 'editPurchase',
      meta: { title: 'editPurchase', icon: 'edit', noCache: true, permissions: ['purchase update'] },
      hidden: true,
    },
    {
      path: 'purchase-report',
      component: () => import('../views/purchase/purchase-report'),
      name: 'purchaseReport',
      meta: {
        title: 'purchase Report',
        icon: 'Memo',
        permissions: ['purchase view'],
      },
      hidden: true,
    },
  ],
};

export default purchaseRoutes;
